// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import UploadDownloadToolBar from "./uploadDownloadToolBar";
import SingleMonthTable from "../reports/table/singleMonthTable";


export class OneTimeSettings extends Parent {

    constructor(props) {
        super(props);

        const {t} = props;

        let tableData = {
            headerNames: [
                t('reports.apartmentName'),
                t('reports.tenantName'),
                t('reports.total_to_pay'),
                t('payment_settings.maxNumberOfInstallments'),
                t('payment_settings.paymentState'),
            ],
            rowsFields: [
                {functionName: 'renderApartmentLink', fieldName:'apartmentName'},
                'tenantName',
                {functionName: 'renderAmount', fieldName:'amount'},
                'numberOfInstallments',
                {functionName: 'renderIsActive', fieldName:'isActive', extraData: {fieldName:'apartmentName'}},
            ]
        }

        this.state = {
            ...tableData,
            ...this.getUploadPaymentState(props),
            title: ''
        }
    }


    async componentDidMount() {
        await this.verifyLoggedIn();
        await this.updateOneTimePaymentSettings();
        const title = await this.buildingTitleText(this.props.match.params.buildingID);
        this.setState({
            title
        });
    }

    async componentDidUpdate(prevProps) {
        const currentOneTimeID = this.props.match.params.oneTimeSettingsID;
        const prevOneTimeID = prevProps.match.params.oneTimeSettingsID;
        if (currentOneTimeID !== prevOneTimeID) {
            await this.updateOneTimePaymentSettings();
        }
    }

    async updateOneTimePaymentSettings() {
        this.startLoader();
        let buildingID = this.props.match.params.buildingID;
        let oneTimeSettingsID = this.props.match.params.oneTimeSettingsID;
        let result = await this.getOneTimePaymentSettings(buildingID, oneTimeSettingsID);
        if (result) {
            result.rows = result?.rows?.sort((a,b)=> { return parseInt(a.apartmentName) <  parseInt(b.apartmentName) ? -1 : 1;})
        }

        this.endLoader();
        this.setState({
            loaded: true,
            ...result
        });
    }

    async getOneTimePaymentSettings(buildingID, oneTimeSettingsID){
        return await this.client.get(`/managers/one-time-payment-settings/${buildingID}/${oneTimeSettingsID}`);
    }

    render() {
        const {t} = this.props;
        const buildingID = this.props.match.params.buildingID;
        let oneTimeSettingsID = this.props.match.params.oneTimeSettingsID;
        const tableState = {buildingID, oneTimeSettingsID};
        if (!this.state.loaded){
            return <div/>
        }

        return (
            <div>
                <h1 className='page-title'>
                    {this.state.title && (
                        <span className='building-title'>{this.state.title}</span>
                    )}
                </h1>
                <UploadDownloadToolBar
                    parentState={this.state}
                    oneTimeSettingsID={oneTimeSettingsID}
                    buildingID={buildingID}
                />

                <SingleMonthTable
                    title={t('payment_settings.oneTimeTitle', {nameOfPayment: this.state.nameOfPayment})}
                    rows={this.state.rows || []}
                    tableType={"oneTimeSettings"}
                    buildingID={buildingID}
                    tableState={tableState}
                    headerNames={this.state.headerNames}
                    fields={this.state.rowsFields}
                />

            </div>
        )
    }
}

export default withTranslation()(OneTimeSettings);

